import React, { PureComponent } from 'react'
import styles from './index.module.less'
import { px2rem } from '@/utils/styleUtils'
import appInstall from '@/utils/appUtils/appInstall'
import { isDuApp } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import qs from 'querystring'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './trackConfig'
import imgResize from '@/utils/img-resize'

interface IProps {
  propsConfig: any
}

@withReactTrack({ createTrackConfig })
class Index extends PureComponent<IProps> {
  static config = {
    name: 'poizon-banner',
  }

  componentDidMount() {}

  handleClick(item) {
    if (typeof window === 'undefined') return
    if ((window as any).editorFlag === 'edit') return
    // 自定义跳转地址
    if (item.targetUrl === '自定义跳转') {
      (window as any).location.href = item.customUrl
      return
    }
    const query = item.query ? `?${item.query}` : ''
    const needScene = this.props.propsConfig?.needScene ?? false
    const [appRouter, h5Router] = item.targetUrl.split('******') ?? []
    if (isDuApp()) {
      Jockeys.openNativePage(appRouter, qs.parse(query.slice(1)))
      return
    }

    if (needScene) {
      appRouter && appInstall(appRouter, qs.parse(query.slice(1)))
      return
    }
    h5Router && ((window as any).location.href = `${h5Router + query}`)
  }

  calculateImgStyle(item) {
    const { list = [] } = this.props?.propsConfig
    const length = list.length
    const {
      paddingTop = 0,
      paddingRight = 0,
      paddingBottom = 0,
      paddingLeft = 0,
      marginTop = 0,
      marginRight = 0,
      marginBottom = 0,
      marginLeft = 0,
    } = item
    let imageStyle: any = {
      width: length === 1 ? '100%' : null,
      paddingRight: length === 1 ? '0' : null,
    }
    imageStyle = {
      ...imageStyle,
      paddingTop: px2rem(paddingTop),
      paddingRight: px2rem(paddingRight),
      paddingBottom: px2rem(paddingBottom),
      paddingLeft: px2rem(paddingLeft),
    }
    if (marginTop) {
      imageStyle.paddingTop = px2rem(marginTop)
    }
    if (marginRight) {
      imageStyle.paddingRight = px2rem(marginRight)
    }
    if (marginBottom) {
      imageStyle.paddingBottom = px2rem(marginBottom)
    }
    if (marginLeft) {
      imageStyle.paddingLeft = px2rem(marginLeft)
    }
    return imageStyle
  }

  render() {
    const list = this.props?.propsConfig?.list || []
    const boxStyle = {}
    return (
      <div className={styles.box} style={boxStyle}>
        {list.length &&
          list.map((item, index) => {
            return (
              <img
                key={item.url}
                data-track-exposure="poizon_venue_component_content_exposure"
                data-track-click="poizon_venue_component_content_click"
                data-index={index}
                onClick={() => this.handleClick(item)}
                className={styles.item}
                data-layzload-src={imgResize(item.url, 750)}
                style={this.calculateImgStyle(item)}
                alt=""
              ></img>
            )
          })}
      </div>
    )
  }
}

export default Index
